import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { EDUVideoService } from '../../../../services';

@Component({
    selector: 'inner-page-nav-section',
    templateUrl: './inner-page-nav-section.component.html',
    styleUrls: ['./inner-page-nav-section.component.scss'],
    standalone: false
})
export class InnerPageNavSectionComponent implements OnInit {
  @Input() titlePassedIn: string;
  @Input() itemsPassedIn: any[];
  @Input() isVideoPage?: boolean;

  constructor(
    public _router: Router,
    private _videoService: EDUVideoService
  ) { }

  ngOnInit(): void {
  }


  goToVideoRoute(_category: string) {
    this._videoService.setVideoCategoryToLocalStorage(_category);
    this._router.navigate(['/videos']);
  }


  sendToDetails(_video) {
    // Don't want .mp4 in the url so splicing it here
    const valueToUse = _video.filename.split('.').slice(0, -1).join('.')
    this._router.navigate(['/videos/' + valueToUse]);
  }
}
